var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09826 3.7876C4.09826 3.37338 4.43405 3.0376 4.84826 3.0376L11.2122 3.0376C11.4111 3.0376 11.6019 3.11662 11.7425 3.25727C11.8832 3.39792 11.9622 3.58869 11.9622 3.7876L11.9622 10.1516C11.9622 10.5658 11.6264 10.9016 11.2122 10.9016C10.798 10.9016 10.4622 10.5658 10.4622 10.1516L10.4622 5.59826L4.31793 11.7425C4.02503 12.0354 3.55016 12.0354 3.25727 11.7425C2.96437 11.4497 2.96437 10.9748 3.25727 10.6819L9.40156 4.5376L4.84826 4.5376C4.43404 4.5376 4.09826 4.20181 4.09826 3.7876Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSiteIcon);
export default __webpack_public_path__ + "static/media/view-site-icon.d9a4ff17916a65c1de5da7fa3ef9a5f5.svg";
export { ForwardRef as ReactComponent };